import React from 'react';
import { dir } from 'i18next';

import { Divider, Stack } from '@lyearn/ui';
import { LANGUAGE_I18N_MAP_WITH_LANG_ENUM } from '@/components/LanguageMenu/consts';
import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';
import ContentRecomendation from '@/modules/corporate/components/DetailPageComponents/ContentRecomendation';
import {
  ContentEntity,
  ContentRecommendationType,
  ContentRecommendationTypeEnum,
} from '@/types/schema';

import DetailsLayoutContainer from './components/DetailsLayoutContainer';
import DetailsLayoutHeroContainer from './components/DetailsLayoutHeroContainer';
import DetailsLayoutSectionContainer from './components/DetailsLayoutSectionContainer';
import { DetailsLayoutProps } from './types';

const DetailsLayout: React.FC<DetailsLayoutProps> = ({
  sections,
  hero,
  classes,
  contentRecommendations,
  badges,
  languageType,
}) => {
  let nlpContents: ContentEntity[] = [];
  let alsContents: ContentEntity[] = [];
  contentRecommendations?.forEach((contentRecommendation: ContentRecommendationType) => {
    if (contentRecommendation.type === ContentRecommendationTypeEnum.Nlp) {
      nlpContents = contentRecommendation.contents;
    } else {
      alsContents = contentRecommendation.contents;
    }
  });

  const contents = [...nlpContents, ...alsContents];
  const { [FeatureFlags.EnableContentRecommendation]: enableContentRecommendation } =
    useFeatureFlags();

  return (
    <DetailsLayoutContainer className={classes?.root}>
      {hero ? (
        <DetailsLayoutHeroContainer className={classes?.hero}>{hero}</DetailsLayoutHeroContainer>
      ) : null}
      <Stack
        dir={languageType ? dir(LANGUAGE_I18N_MAP_WITH_LANG_ENUM[languageType]) : undefined}
        direction="col"
        lang={languageType ? LANGUAGE_I18N_MAP_WITH_LANG_ENUM[languageType] : undefined}>
        <DetailsLayoutSectionContainer
          className={classes?.sections}
          dividerClasses={classes?.divider}
          sections={sections}
        />
      </Stack>
      {contents.length && enableContentRecommendation ? (
        <Stack className="pl-24" direction="col">
          <Divider className="w-full mt-12 mb-[5rem]" />
          <ContentRecomendation contents={contents} />
        </Stack>
      ) : null}
    </DetailsLayoutContainer>
  );
};

export default DetailsLayout;
